import styled from '@emotion/styled';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';


export const RealexLoaderWrapper = styled(Loader, { label: 'RealexLoaderWrapper' })`
    justify-content: center;
    left: 0;
    margin: -6px auto auto;
    position: absolute;
    right: 0;
    top: 50%;
`;
